import React from 'react';
import Breadcrumb from '../common/Breadcrumb';
import { BiPhoneCall } from 'react-icons/bi';

const ContactContainer = () => {
  return (
    <>
      <Breadcrumb
        pageTitle="Contact us"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Contact us" }
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <h2 className="mb-5 text-center">Get In Touch With Us</h2>
               <div className="curved-line mx-auto mt-3"></div>
              <div className="row g-4">
                {/* Address */}
                <div className="col-md-4">
                  <div className="contact-card bg-primary text-white p-4 h-100 border-radius">
                    <div className="d-flex align-items-start gap-3">
                      <i className="fas fa-3x fa-map-marker-alt"></i>
                      <div>
                        <h5 className="mb-2">Our Office</h5>
                        <p className="mb-0">
                          Sector- 3, Udyan 1, Eldeco Colony,<br />
                          Near Bangla Bazar,<br />
                          Lucknow 226002
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-4">
                  <div className="contact-card bg-light p-4 h-100 border-radius">
                    <div className="d-flex align-items-start gap-3">
                      <i className="far fa-3x fa-envelope text-primary"></i>
                      <div>
                        <h5 className="mb-2">Email Us</h5>
                        <p className="mb-0">
                          <a href="mailto:pmseldeco@rediffmail.com" className="text-dark">
                            pmseldeco@rediffmail.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Phone */}
                <div className="col-md-4">
                  <div className="contact-card bg-dark text-white p-4 h-100 border-radius">
                    <div className="d-flex align-items-start gap-3">
                      <BiPhoneCall size={48} />
                      <div>
                        <h5 className="mb-2">Call Us</h5>
                        <p className="mb-0">
                          <a href="tel:+915224232799" className="text-white">
                            +(91) 522 4232799
                          </a>
                        </p>
                        <p className="mb-0">
                          <a href="tel:+916387355032" className="text-white">
                            +(91) 6387355032
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map">
        <div className="container-fluid p-0">
          <div className="row no-gutters">
            <div className="col-12">
              <div className="map h-500">
                <iframe
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7122.913972195626!2d80.925794!3d26.793574!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfc74013481c3%3A0xd3ebaa03a5eed558!2sPioneer%20Montessori%20Inter%20College!5e0!3m2!1sen!2sin!4v1756827799911!5m2!1sen!2sin"
                  className="w-100 h-100"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactContainer;